(() => {
  const scope = '.yhs-reception-v11';
  function choose(form) {
    document.querySelectorAll(`${scope} [data-plan]`).forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.plan === form));
    });
    document.querySelectorAll(`${scope} [data-plan-panel], ${scope} [data-plan-figure]`).forEach(panel => {
      panel.hidden = (panel.dataset.planPanel || panel.dataset.planFigure) !== form;
    });
  }
  function initialize() {
    document.querySelectorAll(scope).forEach(section => {
      if (section.dataset.receptionReady) return;
      section.dataset.receptionReady = 'true';
      const pins = section.querySelectorAll('.pin');
      const details = section.querySelectorAll('.interface-list details');
      pins.forEach(pin => pin.addEventListener('click', () => {
        pins.forEach(other => other.setAttribute('aria-pressed', String(other === pin)));
        details.forEach(detail => { detail.open = detail.id === pin.getAttribute('aria-controls'); });
      }));
      details.forEach(detail => detail.addEventListener('toggle', () => {
        if (!detail.open) {
          const matching = [...pins].find(pin => pin.getAttribute('aria-controls') === detail.id);
          matching?.setAttribute('aria-pressed', 'false');
          return;
        }
        details.forEach(other => { if (other !== detail) other.open = false; });
        pins.forEach(pin => pin.setAttribute('aria-pressed', String(pin.getAttribute('aria-controls') === detail.id)));
      }));
      section.querySelectorAll('[data-plan]').forEach(button => button.addEventListener('click', () => choose(button.dataset.plan)));
      section.querySelectorAll('[data-plan-target]').forEach(link => link.addEventListener('click', () => choose(link.dataset.planTarget)));
      section.querySelectorAll('[data-browse-form]').forEach(link => {
        const group = document.querySelector(`${scope} [data-form-group="${link.dataset.browseForm}"]`);
        if (group) link.href = group.href;
      });
      const previewId = new URL(location.href).searchParams.get('preview_theme_id') ||
        (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null);
      if (previewId) section.querySelectorAll('a[href]').forEach(link => {
        const raw = link.getAttribute('href');
        if (!raw || raw.startsWith('#')) return;
        const url = new URL(raw, location.href);
        if (url.origin === location.origin) {
          if (/^\/collections\/reception-desks(?:\/[^/]*)?$/.test(url.pathname)) {
            url.searchParams.set('view', 'yhs-reception-desks-v11');
          }
          url.searchParams.set('preview_theme_id', previewId);
          link.href = url.toString();
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(() => {
  if (!document.querySelector('.yhs-reception-v11')) return;
  const observed = new WeakSet();
  const place = () => document.body.style.setProperty('--reception-widget-offset', `${Math.max(0, Math.round(document.body.getBoundingClientRect().bottom - innerHeight))}px`);
  addEventListener('scroll', place, { passive: true });
  addEventListener('resize', place);
  new ResizeObserver(place).observe(document.body);
  place();
  const refresh = () => {
    const chat = document.querySelector('shopify-chat')?.shadowRoot;
    const tidio = document.querySelector('#tidio-chat')?.shadowRoot;
    const tidioButton = tidio?.querySelector('#button');
    const open = Boolean(chat?.querySelector('[aria-expanded="true"], shopify-agent-runtime[open]') || tidio?.querySelector('[role="log"], [aria-label="Close chat widget"]') || (tidioButton && !tidioButton.classList.contains('chat-closed')));
    document.body.toggleAttribute('data-reception-chat-open', open);
    [chat,tidio].filter(Boolean).forEach(root => {
      if(observed.has(root)) return;
      observed.add(root);
      new MutationObserver(refresh).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','class','open']});
    });
  };
  new MutationObserver(refresh).observe(document.body,{childList:true});
  let attempts=0;
  const connect=()=>{refresh();if(++attempts<30 && (!document.querySelector('shopify-chat')?.shadowRoot || !document.querySelector('#tidio-chat')?.shadowRoot)) setTimeout(connect,500);};
  connect();
})();
